//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["openStatus", "infoFpObj", "orderId"],
  data() {
    const validatePhone = (rule, value, callback) => {
      const mobileReg = /^(([1][3,4,5,7,8]\d{9})|([0]\d{10,11})|(\d{7,8})|(\d{4}|\d{3})-(\d{7,8}))$/;
      const phoneReg = /^\d{3}-\d{8}|\d{4}-\d{7}$/;
      if(!value || value === ""){
        callback(new Error("公司电话不能为空"));
      }else if(value.length == 11){
        if(!mobileReg.test(value)){
          callback(new Error("请输入正确的手机号码或者固话号码（固话格式：区号-号码）"))
        }else{
          callback();
        }
      }else if(value.length == 12){
        if(!phoneReg.test(value)){
          callback(new Error("请输入正确的手机号码或者固话号码（固话格式：区号-号码）"))
        }else{
          callback();
        }
      }else{
          callback(new Error("请输入正确的手机号码或者固话号码（固话格式：区号-号码）"))
      }
    }
    return {
      stepLoading: false,
      dialogVisible_fp: false,
      fpRules: {
        billTypes: {
          required: true,
          message: "发票类型不能为空",
          trigger: "change",
        },
        status: {
          required: true,
          message: "抬头类型不能为空",
          trigger: "change",
        },
        billTitle: {
          required: true,
          message: "发票抬头不能为空",
          trigger: "blur",
        },
        socialCreditCode: {
          required: true,
          message: "纳税人识别号不能为空",
          trigger: "blur",
        },
        address: {
          required: true,
          message: "公司地址不能为空",
          trigger: "blur",
        },
        telephone: {
          required: true,
          // message: "公司电话不能为空",
          trigger: "blur",
          validator: validatePhone,
        },
        bankName: {
          required: true,
          message: "开户行不能为空",
          trigger: "blur",
        },
        accountNum: {
          required: true,
          message: "银行账号不能为空",
          trigger: "blur",
        },
      },
      dynamicValFpForm: {
        billTypes: "",
        status: "",
        id: "",
        billTitle: "",
        payeeTel: "",
        payeeMailbox: "",
        socialCreditCode: "",
        address: "",
        telephone: "",
        bankName: "",
        accountNum: "",
        orderId: "",
      },
    };
  },
  watch: {
    openStatus(val1, val2) {
      this.dialogVisible_fp = this.openStatus;
    },
    "$store.state.szStatus.szFareDetails": {
      deep: true,
      handler(newValue, oldValue) {
        this.dynamicValFpForm = newValue;
      },
    },
  },
  mounted() {
    this.dynamicValFpForm = this.$store.state.szStatus.szFareDetails;
    // this.dynamicValFpForm.billTitle = this.dynamicValFpForm.billTitle;
  },
  methods: {
    submitForm(formName) {
      this.stepLoading = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitFpList();
        } else {
          return false;
        }
      });
    },
    selectTRadio(val) {
      this.dynamicValFpForm.status = val;
    },
    selectFpRadio(val) {
      this.dynamicValFpForm.billTypes = val;
    },
    // 修改发票接口
    submitFpList() {
      if (this.dynamicValFpForm.orderId != "") {
        this.stepLoading = true;
        this.$http.szOrder.editInvoice(this.dynamicValFpForm).then((res) => {
          this.stepLoading = false;
          if (res.status == 1) {
            this.dialogVisible_fp = false;
            this.$emit("closeStatus", true);
            this.$message({
              message: "修改成功",
              type: "success",
            });
            setTimeout(() => {
              this.stepLoading = false;
            }, 1000);
          }
        });
      } else {
        this.dialogVisible_fp = false;
        this.$emit("closeStatus", true);
        this.$emit("addSzFp", this.dynamicValFpForm);
      }
    },
    handleClose() {
      this.dialogVisible_fp = false;
      this.$emit("closeStatus", true);
    },
  },
};
